export default __webpack_public_path__ + "static/media/group2.f323f7a9.png";